<template>
    <div>
        <template v-if="permission == true">
            <div class="page-top mb-1 mb-3">
                <h1> Edit Account Type</h1>
            </div>
            <div class="global-main">
                <form @submit.prevent="submitForm">
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label> Name </label>
                            <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Risk Rating </label>
                            <select v-model="form.risk_rating_id" name="risk_rating_id" class="selectpicker custom-select2" :class="{ 'form-control is-invalid': form.errors.has('risk_rating_id') }">
                                <option value="" selected>Select Risk Rating</option>
                                <option v-for="rRating in riskRatings" v-bind:value="rRating.id" v-bind:key="rRating.id">
                                    {{ rRating.rating }}
                                </option>
                            </select>
                            <has-error :form="form" field="risk_rating_id"></has-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/accountTypes" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="permission === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="permission === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    name : '',
                    risk_rating_id: ''
                }),
                permission: null,
                riskRatings: []
            };
        },
        methods: {
            submitForm() {
                this.$Progress.start();
                this.form.post('/api/addOrUpdateAccountTypes')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success','Account Type updated successfully');
                            this.$router.push('/accountTypes');
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Some error in your form data');
                        }
                    })
                    .catch(err => {
                        this.promptValidationErrors(err, 'Some error in your form data');
                        this.$Progress.fail();
                    });
            },
            getAccountType(){
                axios.get('/api/getAccountType/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.form.id = res.data.record.id;
                        this.form.name = res.data.record.type;
                        //rating map
                        if (res.data.record.risk_rating > 10) {
                            this.form.risk_rating_id = 1;
                        } else if (res.data.record.risk_rating > 5 && res.data.record.risk_rating <= 10) {
                            this.form.risk_rating_id = 2;
                        } else if (res.data.record.risk_rating <= 5) {
                            this.form.risk_rating_id = 3;
                        }
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                });
            },
            getRiskRatings() {
                axios.get('/api/riskRatings')
                .then(res => {
                    this.riskRatings = res.data.data;
                }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    console.log(err);
                });
            }
        },
        mounted() {
            this.$Progress.start();
			this.can('crud_cities').then(result => {
                this.permission = result.crud_cities;
            }).then(result => {
                if(this.permission == true){
                    this.getAccountType();
                    this.getRiskRatings();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        }
    }
</script>
